<template>
    <div class="map-switch">
        <ul :class="mapSwitchDirection? '': 'clearfix'">
            <li @click="mapSwitch(item, index)" :class="[mapSwitchActive === item.type? 'switch-li active' : 'switch-li', mapSwitchDirection? '': 'transverse']" v-for="(item, index) in switchList" :key="'switchList'+ index">
                <div :class="'iconfont '+item.icon"></div>
                <div v-html="item.title"></div>
            </li>
        </ul>
    </div>
</template>
<script>
import bus from '@/components/common/bus'
export default {
  data() {
    return {
      switchList: [{
        title: '全部',
        type: '0',
        icon: 'icon-quanbu'
      }, {
        title: '工业',
        type: '3',
        icon: 'icon-gongye'
      }, {
        title: '商业',
        type: '2',
        icon: 'icon-shangye'
      }, {
        title: '住宅',
        type: '1',
        icon: 'icon-zhuzhai'
      }, {
        title: '其他',
        type: '4',
        icon: 'icon-qita1'
      }
      ],
      mapSwitchActive: '0',
      mapSwitchDirection: false
    }
  },
  methods: {
    mapSwitch(item) {
      this.mapSwitchActive = item.type
      bus.$emit('mapSelectedQueryValue', item.type)
    },
    clientHeight() {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        this.mapSwitchDirection = true
      } else {
        if (document.body.clientHeight > 769) {
          this.mapSwitchDirection = true
        } else {
          this.mapSwitchDirection = false
        }
      }
    }
  },
  mounted() {
    bus.$on('mapSelectedQueryValue', msg => {
      this.mapSwitchActive = msg
    })
    this.clientHeight()
    window.onresize = () => (() => {
      this.$nextTick(() => {
        this.clientHeight()
      })
    })()
  }
}
</script>
<style lang="scss" scope>
    .map-switch{
        position: absolute;
        top: 98px;
        right: 5px;
        z-index: 1199;
        .switch-li{
            margin-bottom: 16px;
            width: 58px;
            height: 58px;
            background: rgba(255,255,255,0.90);
            border-radius: 4px;
            box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
            text-align: center;
            color: #2F80ED;
            padding-top: 9px;
            cursor: pointer;
            &:hover,&.active{
                background: #2f80ed;
                color: #fff;
            }
            .iconfont{
                font-size: 24px;
            }
            &.transverse{
                float: left;
                margin-left: 10px;
                &:first-child{
                    margin-left: 0px;
                }
            }
        }
    }
</style>
